import http from './http'

export default {
  searchHandle(searchString) {
    return http.post('handles/findHandle', {
      search: searchString,
    })
  },
}
